import { Injectable } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import {filter} from 'rxjs/operators'

interface Mapping {
  match: string[];
  target: string;
  paramMap: { [key: string]: string };
  valueMap?: { [key: string]: { [key: string]: string } };
}

@Injectable({ providedIn: 'root' })
export class UrlRedirectService {

  private mappings: Mapping[] = [];

  constructor(private http: HttpClient, private router:Router) {

    this.http.get<Mapping[]>('assets/url-redirects.json').subscribe((data) => {
      this.mappings = data;
      this.checkAndRedirect();
    });

    this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe(() => {
          this.checkAndRedirect(); 
        });

    
  }

  checkAndRedirect(): void {
    const hash = window.location.hash || '';
    const queryPart = hash.includes('q=') ? hash.split('q=')[1] : '';
    const params = this.parseParams(queryPart);

    let defaultRoute = "https://muse.merck.com/project/searchnav"

    if (queryPart.toLowerCase().includes('vees')) {
      window.location.href = defaultRoute; 
      return;
    }else if (queryPart.toLowerCase().includes('spouniqueid')) {
      window.location.href = defaultRoute; 
      return;
    }

    if (params['f-source'] && params['f-source'].toLowerCase() === 'idea exchange') {
      window.location.href = defaultRoute; 
      return;
    }

    
    const paramKeys = Object.keys(params).map(k => k.trim().toLowerCase());

    console.log('Parsed params:', JSON.stringify(params));
    let redirectReady = true;

    for (const mapping of this.mappings) {
      // const matched = mapping.match.every((key) => key in params);
      const mappingKeys = mapping.match.map(k => k.trim().toLowerCase());

      const keysMatchExactly =
      mappingKeys.length === paramKeys.length &&     
      mappingKeys.every(k => paramKeys.includes(k)); 
      

      if (keysMatchExactly) {
        const targetUrl = new URL(mapping.target);
        for (const sourceParam of mapping.match) {
         

          const targetParam = mapping.paramMap[sourceParam] || sourceParam;
          let value = params[sourceParam];

          const valueMap = mapping.valueMap?.[sourceParam];
          if (valueMap) {
            redirectReady = false
          }

          if (valueMap && valueMap[value]) {
            value = valueMap[value];
            redirectReady = true;
          }

          targetUrl.searchParams.set(targetParam, value);
        }

        if (redirectReady){
          console.log('Redirecting to:', targetUrl.toString());
          window.location.href = targetUrl.toString();
          return;
        }
      }
    }
  }

  private parseParams(query: string): { [key: string]: string } {
    const params: { [key: string]: string } = {};
    query.split('&').forEach((part) => {
      const [keyRaw, value] = part.split('=');
      if (keyRaw && value) {
        const key = keyRaw.replace('@', '').trim();
        params[key] = decodeURIComponent(value);
      }
    });
    return params;
  }


  private normalize(value: string): string {
    return value?.trim().replace(/\s+/g, ' ').toLowerCase();
  }
}